// src/lib/localizeCard.js
// Per-language card fields follow the existing suffix convention
// (label_en, image_en, back_en, descrizione_breve_en). Base fields are the
// Italian originals and the fallback for any missing translation.
const pick = (obj, field, lang) => (lang && lang !== 'it' && obj[`${field}_${lang}`]) || obj[field] || '';

export function localizeCard(card, lang) {
  return {
    ...card,
    label: pick(card, 'label', lang),
    image: pick(card, 'image', lang),
    back: pick(card, 'back', lang),
    descrizione_breve: (lang && card[`descrizione_breve_${lang}`]) || card.descrizione_breve_it || '',
  };
}

export const localizeGroup = (group, lang) => ({ ...group, label: pick(group, 'label', lang) });

// Keeps position/flip/etc., swaps only language-dependent display data.
// Matching is by card id (canvas card node id === Firestore card doc id), so
// it also fixes up sessions saved in another language.
export function relocalizeCardNodes(nodes, deckCards) {
  const byId = new Map(deckCards.map((c) => [c.id, c]));
  return nodes.map((n) => {
    const c = n.type === 'customCardNode' && byId.get(n.id);
    return c ? { ...n, data: { ...n.data, label: c.label, image: c.image, backImage: c.back, descrizioneBreve: c.descrizione_breve } } : n;
  });
}

export function relocalizeCardList(list, deckCards) {
  const byId = new Map(deckCards.map((c) => [c.id, c]));
  return list.map((x) => {
    const c = byId.get(x.id);
    return c ? { ...x, label: c.label, image: c.image, descrizioneBreve: c.descrizione_breve } : x;
  });
}

// usedCards entry for a card the mentor's magic cursor just landed. Label and
// image come from the CURRENT deck (by card id), not from the move snapshot,
// which may predate a language switch mid-flight.
export function usedCardEntry(move, deckCards) {
  const c = (deckCards || []).find((x) => x.id === move.nodeId);
  return c
    ? { id: c.id, label: c.label, group: c.groupId, image: c.image, descrizioneBreve: c.descrizione_breve }
    : { id: move.nodeId, label: move.label, group: move.group, image: move.image, descrizioneBreve: move.descrizioneBreve };
}

// Moves a card from unused to used by id (labels change with the language).
export function moveCardToUsed(used, unused, move, deckCards) {
  return {
    used: used.some((c) => c.id === move.nodeId) ? used : [...used, usedCardEntry(move, deckCards)],
    unused: unused.filter((c) => c.id !== move.nodeId),
  };
}
